import { render, staticRenderFns } from "./DepartSelect.vue?vue&type=template&id=5db63df4&scoped=true"
import script from "./DepartSelect.vue?vue&type=script&lang=js"
export * from "./DepartSelect.vue?vue&type=script&lang=js"
import style0 from "./DepartSelect.vue?vue&type=style&index=0&id=5db63df4&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db63df4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5db63df4')) {
      api.createRecord('5db63df4', component.options)
    } else {
      api.reload('5db63df4', component.options)
    }
    module.hot.accept("./DepartSelect.vue?vue&type=template&id=5db63df4&scoped=true", function () {
      api.rerender('5db63df4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tools/DepartSelect.vue"
export default component.exports